import React, { ReactElement } from 'react';
import { IInitialValue } from '../entities/types';
import PositionToggle from '../../../PositionToggle';

const TogglePositionCell = ({ initialValue }: { initialValue: IInitialValue }): ReactElement => {
  return <>{initialValue.displayToggle && <PositionToggle positionUuid={initialValue.positionUuid} />}</>;
};

export default TogglePositionCell;
